module.exports = __webpack_public_path__ + "media/images/logo-rema-black-4c1e43705ac8ee03307a8d9bc0af7f1c.svg";